import React from 'react';
import cx from 'classnames';

import { AccordionProps } from '.';

export interface AccordionGroupProps {
  /** Child of `Accordion.Group` which should be one or more `Accordion.Item`. */
  children:
    | React.ReactElement<AccordionProps>
    | React.ReactElement<AccordionProps>[];
  /** Apply CSS className for `Accordion.Group` container. */
  className?: Parameters<typeof cx>[0];
}

export interface AccordionComposite {
  Group: React.FC<AccordionGroupProps>;
  Item: React.FC<AccordionProps>;
}

export const AccordionGroup: React.FC<AccordionGroupProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cx(className)}>
      {/* Pass down the index value to the `Accordion.Item` */}
      {React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement, {
            itemIndex: index,
          });
        }
        return null;
      })}
    </div>
  );
};

AccordionGroup.displayName = 'AccordionGroup';

export default AccordionGroup;
